import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    // Keep requested trailing-slash URLs (e.g. /accommodations/) without rewriting
    // asset paths like /__l5e/.../image.jpg.
    trailingSlash: "preserve",
  });

  return router;
};
